import { Form, Col, Row } from 'react-bootstrap';

import { FormSelectField } from '_components/_core';

import { AsaasFields, BancoInterFields } from '../GatewayFields';

function GatewayDetails({
  values,
  setFieldValue,
  errors,
  touched,
  availablePaymentGateways,
  setMnemonic,
  gatewayOptions,
}) {
  return (
    <>
      <Row>
        <Col md={12}>
          <Form.Group className="mb-3">
            <Form.Label>Gateway de Pagamento</Form.Label>
            <FormSelectField
              name="payment_gateway_id"
              options={gatewayOptions(availablePaymentGateways)}
              valueKey="id"
              labelKey="name"
              placeholder="Selecione um gateway de pagamento"
              onChange={selectedOption => {
                setFieldValue('payment_gateway_id', selectedOption.value);
                setFieldValue('mnemonic', selectedOption.mnemonic);
                setMnemonic(selectedOption.mnemonic);
              }}
              isSearchable={false}
            />
            <Form.Control.Feedback type="invalid">
              {errors.payment_gateway_id}
            </Form.Control.Feedback>
          </Form.Group>
        </Col>
      </Row>
      {['ASAAS', 'ASAAS_SANDBOX'].includes(values.mnemonic) && (
        <AsaasFields
          values={values}
          setFieldValue={setFieldValue}
          errors={errors}
          touched={touched}
        />
      )}
      {['BANCO_INTER'].includes(values.mnemonic) && (
        <BancoInterFields
          values={values}
          setFieldValue={setFieldValue}
          errors={errors}
          touched={touched}
        />
      )}
    </>
  );
}

export default GatewayDetails;
